var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Checkbox, Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { conversationChannelAttributes, } from 'lib-shared-legacy-types';
import { useEffect } from 'react';
import { useSetState } from 'react-use';
import { analytics } from 'app/utils/segment';
import { bansApi } from 'hooks/useBans/api';
import { isIpAddress, } from 'hooks/useBans/types';
import { useNotifications } from 'hooks/useNotifications';
import styles from './banUserModal.module.scss';
const { banUser, banIp, getUserBans } = bansApi;
export const BanUserModal = (props) => {
    var _a;
    const [state, setState] = useSetState({
        isBanning: false,
        shouldBanIp: false,
    });
    const notify = useNotifications();
    useEffect(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            const { ipAddress } = props;
            if (ipAddress && isIpAddress(ipAddress)) {
                const { data: { number_of_bans }, } = yield getUserBans({
                    params: {
                        ip_address: ipAddress,
                        active_state: 'active',
                        // slight hack - we only need the number of bans, not the actual bans objects
                        limit: 0,
                    },
                });
                setState({
                    numberOfbannedUsersOnIpAddress: number_of_bans,
                });
            }
        });
        fetchData();
    }, []);
    const handleClose = (event) => {
        props.onClose(event);
    };
    const handleConfirm = () => __awaiter(void 0, void 0, void 0, function* () {
        const { reason, ban_period, shouldBanIp } = state;
        const { channel, csid, user, ipAddress } = props;
        analytics.bansBanUserClicked({
            ipChecked: shouldBanIp,
            channel,
        });
        if (user.is_agent) {
            const notificationOptions = {
                title: 'Can not ban agent',
                text: `It's not possible to ban an agent.`,
                icon: 'exclamation',
                type: 'warning',
            };
            notify(notificationOptions);
            return;
        }
        try {
            setState({ isBanning: true });
            const response = yield banUser(user.id, {
                channel,
                csid,
                ban_period,
                reason,
            });
            if (shouldBanIp && ipAddress && isIpAddress(ipAddress)) {
                yield banIp(ipAddress, {
                    channel,
                    csid,
                    ban_period,
                    reason,
                });
            }
            const notificationPayload = {
                title: 'User banned',
                text: `User has been banned`,
                icon: 'i-done',
                className: 'success',
                time: 5000,
            };
            notify(notificationPayload);
            setState({ isBanning: false });
            handleClose({ response });
        }
        catch (error) {
            setState({ isBanning: false });
            const notificationPayload = {
                title: 'An error occurred',
                text: `An error occurred when trying to ban user`,
                icon: 'i-exclamation',
                className: 'danger',
            };
            notify(notificationPayload);
            throw new Error('Failed to ban user');
        }
    });
    const handleCancel = () => {
        handleClose({ canceled: true });
    };
    const onBanIpChangeHandler = () => {
        setState(({ shouldBanIp }) => ({
            shouldBanIp: !shouldBanIp,
        }));
    };
    const { isOpen, user, channel, csid, ipAddress: ip } = props;
    const { name, email } = user;
    const { shouldBanIp, numberOfbannedUsersOnIpAddress } = state;
    const channelName = (_a = conversationChannelAttributes.get(channel)) === null || _a === void 0 ? void 0 : _a.prettyName;
    const userIdentity = `${name || ''} ${email || ''}`.trim();
    const ipAddressMessage = numberOfbannedUsersOnIpAddress && numberOfbannedUsersOnIpAddress > 0 ? (_jsxs(Box, { children: [numberOfbannedUsersOnIpAddress, " other", ' ', numberOfbannedUsersOnIpAddress === 1 ? 'user has' : 'users have', ' ', "already been banned from this IP address ", _jsx("strong", { children: ip })] })) : (false);
    const withCsidMessage = (_jsxs(Text.Paragraph, { children: ["Are you sure you want to ban user ", _jsx("strong", { children: userIdentity }), "? User will be unable to reply.", ipAddressMessage, ip && (_jsxs(Box, Object.assign({ className: styles.ipBanContainer }, { children: [_jsx(Box, Object.assign({ as: "span", className: styles.checkboxContainer }, { children: _jsx(Checkbox, { name: "shouldBanIp", onChange: onBanIpChangeHandler, checked: shouldBanIp }) })), _jsxs(Text.Paragraph, Object.assign({ as: "span" }, { children: ["Also ban user IP address: ", _jsx("strong", { children: ip })] }))] })))] }));
    const withoutCsidMessage = (_jsxs(Text.Paragraph, { children: ["Are you sure you want to ban user ", _jsx("strong", { children: name }), " on", ' ', _jsx("strong", { children: channelName }), " channel?", ipAddressMessage] }));
    const message = csid ? withCsidMessage : withoutCsidMessage;
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleCancel }, { children: [_jsx(ModalHead, { title: "Are you sure?", onClose: handleCancel }), _jsx(ModalBody, { children: message }), _jsx(ModalFoot, { cancelName: "Cancel", cancelOnClick: handleCancel, confirmName: "Ban user", confirmProps: {
                    variant: 'danger',
                    isLoading: state.isBanning,
                    loadingIndicator: (_jsx(Text.Paragraph, Object.assign({ as: "span", variant: "3", wrap: "nowrap", color: "inherit" }, { children: "Banning..." }))),
                }, confirmOnClick: handleConfirm })] })));
};
